import { sortBy } from 'lodash';
import { minuteIntToDigit } from 'utils/convertTimeUnits';

const offsetToGMTView = offset =>
  offset < 0
    ? `-${minuteIntToDigit(-offset)}:00`
    : `+${minuteIntToDigit(offset)}:00`;

export const mapTimezoneOptionsFromApiModel = timezoneData =>
  sortBy(timezoneData, 'name').map(
    ({ gmt_offset: gmtOffset, name, offset, value }) => ({
      label: `(GMT${offsetToGMTView(gmtOffset || 0)}) ${name}`,
      value,
      offset,
    }),
  );
